module.exports = __webpack_public_path__ + "static/media/shelter_beach_3.721abd9c.svg";